import React, { useEffect, useState } from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { faAngleLeft, faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import 'swiper/css';
import 'swiper/css/navigation';
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { get_product_news } from "../../redux/actions/home";
import ItemProducto from "../../widgets/item_producto";

const breakpoints = {
    300: { slidesPerView: 2, spaceBetween: 5 },
    400: { slidesPerView: 2, spaceBetween: 10 },
    640: { slidesPerView: 2, spaceBetween: 15 },
    768: { slidesPerView: 3, spaceBetween: 15 },
    992: { slidesPerView: 4, spaceBetween: 20 },
    1200: { slidesPerView: 5, spaceBetween: 20 },
};

function ProductNews({ get_product_news, product_news }) {
    const [arrayProducts, setArrayProducts] = useState([]);

    useEffect(() => {
        if (product_news.length === 0) {
            get_product_news();
        } else {
            setArrayProducts(product_news);
        }
    }, [product_news, get_product_news]);

    const navigationPrevRef = React.useRef(null);
    const navigationNextRef = React.useRef(null);

    const updateFavoriteStatus = (productId, isFavorite) => {
        const updatedProducts = arrayProducts.map(product =>
            product.id === productId
                ? { ...product, is_favorite: isFavorite ? 1 : 0 }
                : product
        );
        setArrayProducts(updatedProducts);
    };

    return (
        <div className="relative container pb-6">
            {/* Encabezado */}
            <div className="flex justify-between items-center pb-0.5 border-b border-brand-blue">
                <h2 className="text-lg font-bold text-brand-blue">Novedades</h2>
                <Link to={`las/novedades`} className="text-white bg-brand-blue hover:bg-blue-700 transition-colors duration-300 px-2 py-1 rounded-full text-sm font-medium no-underline">
                    Ver Más
                    <FontAwesomeIcon icon={faAngleRight} className="ps-2 text-sm" />
                </Link>
            </div>

            {/* Flechas de navegación */}
            {/* <div ref={navigationPrevRef} className="hidden md:flex absolute left-[-2rem] top-1/2 transform -translate-y-1/2 z-10">
                <button className="h-10 w-10 bg-brand-blue hover:bg-blue-700 transition-colors duration-300 rounded-full text-white flex justify-center items-center shadow-lg">
                    <FontAwesomeIcon icon={faAngleLeft} className="text-xl" />
                </button>
            </div>
            <div ref={navigationNextRef} className="hidden md:flex absolute right-[-2rem] top-1/2 transform -translate-y-1/2 z-10">
                <button className="h-10 w-10 bg-brand-blue hover:bg-blue-700 transition-colors duration-300 rounded-full text-white flex justify-center items-center shadow-lg">
                    <FontAwesomeIcon icon={faAngleRight} className="text-xl" />
                </button>
            </div> */}

            {/* Swiper */}
            <Swiper
                breakpoints={breakpoints}
                spaceBetween={15}
                navigation={{
                    prevEl: navigationPrevRef.current,
                    nextEl: navigationNextRef.current,
                }}
                onBeforeInit={(swiper) => {
                    swiper.params.navigation.prevEl = navigationPrevRef.current;
                    swiper.params.navigation.nextEl = navigationNextRef.current;
                }}
                modules={[Navigation]}
                className="mySwiper mt-1 md:mt-3 p-1 md:p-2 pb-1 md:pb-3"
            >
                {arrayProducts.map((product, index) => (
                    <SwiperSlide key={index}>
                        <ItemProducto
                            product={product}
                            updateFavoriteStatus={updateFavoriteStatus}  // Pasamos la función
                        />
                    </SwiperSlide>
                ))}
            </Swiper>
        </div>
    );
}

const mapStateToProps = state => ({
    product_news: state.Home.product_news
});

export default connect(mapStateToProps, {
    get_product_news
})(ProductNews);
